function About() {
  return (
    <section id="sobre" className="about">
        <div className="container about-container">
        <div className="about-text">
            <h2>Quem Somos</h2>
            <p>A <strong>GMED</strong> é referência em <strong>locação de equipamentos hospitalares</strong>, oferecendo <strong>camas hospitalares elétricas e manuais, cadeiras de rodas, cadeiras de banho, assentos para banho e guinchos para remoção de pacientes obesos</strong>.</p>
            <p>Nosso compromisso é garantir <strong>segurança, conforto e praticidade</strong> para pacientes e cuidadores, sempre com <strong>equipamentos de qualidade e higienizados</strong>.</p>
        </div>
        <div className="about-image">
            <img src="images/guincho.jpg" alt="Guincho para remoção de pacientes" />
        </div>
        </div>
    </section>
  );
}

export default About;
